import Api from "./Api.js";

const resource = "/gift-cards";

export default {
  search(params) {
    return Api.get(`${resource}`, { params });
  },
};
